import { authHeader } from '../Helpers';
import Swal from 'sweetalert2';

export const api = (req, input) => {
	const requestOptions = {
		method: req.method,
		headers:  authHeader()
	};
  if(req.method === "POST") {
    let formData = new FormData();
    if(input instanceof FormData) {
      formData = input;
    } else {
      Object.keys(input).map((val) => {
        if(typeof(input[val])=="object") {
          input[val] = JSON.stringify(input[val]);
        }
        formData.append(val, input[val]);
      });
    }
    requestOptions.body = formData;
  }
  return fetch(req.url, requestOptions).then(res => {
    if(res.status === 401) {
      return res;
      // useNavigate("/logout");
    }    
    return res.json();
  }).then(res => {
    if(req.method === "POST" && !req.no_popup_msg) {
      Swal.fire({
        title: res.msg,
        text: res.desc,
        icon: res.type,
        backdrop: false,
      });
    }
    return res;
  }).catch(err => {
    console.log(err);
  });
}